// frontend/src/pages/learning/OtherAssignmentTopicList.js
const modules = [
  { 
    owner:'Think5Whys', 
    code: 't5wasoth101', 
    sn:'1', 
    title: 'Hydrogen as fuel', 
    landingPageUrl: '/otherAssignments/add', 
    topictype: 'Periodic Table & Elements', 
    desc: '<p>Explore the use of hydrogen as a fuel, its advantages and challenges, and its potential role in future energy systems. <strong>Use Peridoic Table Flash Card Multimedia Book Hydrogen page on Think5Whys platform to make Notes & compile as many video or other links you refer to strengthen your study and making this assignment. Later access the FlipNotes & VideoBooks to regather the learnings.</strong></p><p style="color: blue;">Write assignment report here!</p>' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5wasoth102', 
    sn:'2', 
    title: 'Lithium as a Source for Batteries', 
    landingPageUrl: '/otherAssignments/add', 
    topictype: 'Periodic Table & Elements', 
    desc: '<p>Investigate the role of lithium in battery technology, focusing on its applications in electronics and electric vehicles, as well as the associated benefits and challenges.</p><p><strong>Use Peridoic Table Flash Card Multimedia Book Lithium page on Think5Whys platform to make Notes & compile as many video or other links you refer to strengthen your study and making this assignment. Later access the FlipNotes & VideoBooks to regather the learnings.</strong></p><p style="color: blue;">Write assignment report here!</p>' 
  },
  { 
    owner:'Think5Whys', 
    code: 't5wasoth103', 
    sn:'3', 
    title: 'Chlorine as a Disinfectant', 
    landingPageUrl: '/otherAssignments/add', 
    topictype: 'Periodic Table & Elements', 
    desc: '<p>Examine the role of chlorine as a disinfectant, particularly in water treatment and household cleaning, including its effectiveness, benefits, and potential risks.</p><p><strong>Use Peridoic Table Flash Card Multimedia Book Chlorine page on Think5Whys platform to make Notes & compile as many video or other links you refer to strengthen your study and making this assignment. Later access the FlipNotes & VideoBooks to regather the learnings.</strong></p><p style="color: blue;">Write assignment report here!</p>'
  }
];

export default modules;

